<template>
  <div>
    <vm-table
        ref="vmTable"
        height="63vh"
        :filter.sync="filter"
        module="basic"
        url="thyssenMarkRules"
        @select="selectTest">
      <el-button
          slot="toolbar"
          type="primary"
          size="mini"
          @click="$refs.editPage.open(0)">
        新增
      </el-button>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="关键词">
            <el-input v-model.trim="filter.filter" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="product" label="客户类别">
        <template slot-scope="scope">
          {{scope.row.product ? "上海" : "中山"}}
        </template>
      </el-table-column>
      <el-table-column prop="computerRoomTyp" label="机房类型">
        <template slot-scope="scope">
          {{scope.row.computerRoomTyp ? "有机房" : "无机房"}}
        </template>
      </el-table-column>
      <el-table-column prop="inverterPower" label="功率"/>
      <el-table-column prop="cabinetType" label="柜体型号"/>
      <el-table-column prop="boxSize" label="尺寸"/>
      <el-table-column prop="netWeight" label="净重"/>
      <el-table-column prop="grossWeight" label="毛重"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="120px">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.editPage.open(scope.row.pkid)">编辑</el-button>
          <el-button type="danger" @click="deleteRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <thyssen-mark-rule-edit ref="editPage" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import ThyssenMarkRuleEdit from "@/views/information/ThyssenMarkRule/ThyssenMarkRuleEdit.vue";

  export default {
    name: "ThyssenMarkRule",
    components: {ThyssenMarkRuleEdit, VmTable, VmSearch},
    data() {
      return {
        idList: "",
        filter: {
          filter: "",
        },
      };
    },
    mounted() {
      this.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      deleteRow(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic","/thyssenMarkRules", row.pkid).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
